import { Component, Input } from '@angular/core';
import { NavigationItem } from './nav-item.model';

import { RouterLink } from '@angular/router';

@Component({
  selector: 'np-nav',
  standalone: true,
  imports: [RouterLink],
  templateUrl: 'nav.component.html',
})
export class NavComponent {
  @Input() navItems: NavigationItem[] = [];
}
